import { Component, Prop, Vue } from 'vue-property-decorator';
import html2pdf from 'html2pdf.js';
import { TransactionInfo } from '@/core/payment-card/interfaces';
import { CurrencyInfo } from '@/core/currency/interfaces';
import { Order } from '@/views/checkout/interfaces';

@Component({})
export default class LoyaltyReceipt extends Vue {
    @Prop(Object)
    transactionInfo: TransactionInfo;

    @Prop(Object)
    currency: CurrencyInfo;

    @Prop(Object)
    order: Order

    handleReceipt() {
        const options = {
            filename: 'receipt.pdf',
            margin: 1,
            image: { type: 'jpeg' as const, quality: 0.98 },
            jsPDF: { unit: 'in', format: 'letter' }
        };
        const receipt = document.getElementById('loyalty-receipt');

        if (!receipt) {
            return;
        }

        html2pdf().set(options).from(receipt).toPdf()
            .get('pdf')
            .then((pdf) => {
                window.open(pdf.output('bloburl'), '_blank');
            });
    }
}
